import axios, { AxiosError, AxiosResponse } from "axios";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Odc, { removeHandlingTimesForSubTypes } from "../Odc";
import { odcUrls } from "../../URL/ApplicationUrls";
import { MdmApiError } from "../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../Errors/apiErrorNotificationToast";

export const useAddOdc = () => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (odc: Odc) => {
      return axios.post<Odc>(odcUrls.addOdc.apiUrl, removeHandlingTimesForSubTypes(odc));
    },
    onSuccess: async (response: AxiosResponse<Odc>) => {
      const odc = response.data;
      navigate(odcUrls.editOdc(odc.Id).uiPath);
      toast.success(`The ODC with the Id ${odc.Id} has been created`);
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
